var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ModalComponentAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
import { Alert, useStyles } from "../style";
export var ModalClone = function (props) {
    var classes = useStyles();
    return (_jsx(ModalComponentAFY, __assign({ openModal: props.openModalConfirmClone, backgroundColor: "#ffffff", onClose: function () {
            props.setOpenModalConfirmClone(false);
        }, border: 0, minWidthModal: "500px", padding: 30 }, { children: _jsx(Alert, { children: "esta funci\u00F3n aun no esta disponible" }) })));
};
